const INVITE_LOGIN_PARAM_NAMES = ['organization', 'connection', 'login_hint'] as const;

export function buildInviteLoginAuthorizationParams(
    search: string,
): Partial<Record<(typeof INVITE_LOGIN_PARAM_NAMES)[number], string>> {
    const urlParams = new URLSearchParams(search);
    const authorizationParams: Partial<Record<(typeof INVITE_LOGIN_PARAM_NAMES)[number], string>> =
        {};

    for (const paramName of INVITE_LOGIN_PARAM_NAMES) {
        const value = urlParams.get(paramName);
        if (value) {
            authorizationParams[paramName] = value;
        }
    }

    return authorizationParams;
}
